module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/cFhljK/tc-custom/9789948731955.jpg?1737166184422",
      "alt": "This image is the cover for the book Amelia"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Amelia\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Discover the remarkable life of a little girl named Amelia in this captivating tale. Witness the twists and turns of her journey, each event more compelling than the last. This book, though brief, is deeply rooted in reality and is sure to keep you hooked from start to finish. Filled with magic, hope, gratitude, kindness, and courage, it explores the challenges of daily life, especially when you feel alone. Amelia’s story emphasizes the importance of making decisions for yourself and leading your life with strength and unwavering faith in the Almighty, regardless of the circumstances. In a world where the future is uncertain, this book offers valuable lessons. It teaches us to keep moving forward, trust ourselves, and remain hopeful. Through Amelia’s experiences, you’ll learn to believe in yourself and see how everything eventually falls into place. Life’s lessons help us grow, and through this book, you’ll find inspiration and encouragement to navigate your own journey.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tasneem Khamkar\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("I am Tasneem. Born and raised in the UAE, now I am a resident of this wonderful country. I am a Certified Human Resources Professional, a Motivation Counsellor, and a community worker. This book will be my first write-up, and I will be writing more books in coming years, and would love to be known as a successful author. In need of your love, support and prayers for me. Thanks")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0